import * as React from "react";
const SvgSupport = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,1A9,9 0 0,0 3,10V17A3,3 0 0,0 6,20H9V14H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V14H15V20H18A3,3 0 0,0 21,17V10A9,9 0 0,0 12,1Z" }));
export default SvgSupport;
